var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 39,
    viewBox: "0 0 63 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 21,
    r: 7,
    fill: "#0A72ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9092,
    cy: 32,
    r: 7,
    fill: "#0A72ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8184,
    cy: 20,
    r: 7,
    fill: "#0A72ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7271,
    cy: 7,
    r: 7,
    fill: "#0A72ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteLoader);
export default __webpack_public_path__ + "static/media/complete-loader.ce86b0c1.svg";
export { ForwardRef as ReactComponent };